export default "__VITE_ASSET__CGLhyRhk__"